import { getUrl, Request } from '../../request';

export const getPopup = (city_id, category_id) => {
  const query = {
    city_id,
    category_id
  };
  return Request.get(getUrl(`/api/v1/content/popups/`), query);
};
